import { render, staticRenderFns } from "./HowToAddBox.vue?vue&type=template&id=4d1e87cc&scoped=true"
import script from "./HowToAddBox.vue?vue&type=script&lang=js"
export * from "./HowToAddBox.vue?vue&type=script&lang=js"
import style0 from "./HowToAddBox.vue?vue&type=style&index=0&id=4d1e87cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e87cc",
  null
  
)

export default component.exports